<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="false">
    <h6 slot="header" class="modal-title text-success font-weight-bold" id="modal-title-default">Ubah Password</h6>
    <div class="d-block">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form ref="form" @submit.stop.prevent="handleSubmit(register)">
          <p class="description">* Silahkan ubah password Anda dengan melengkapi form dibawah ini.</p>
          <div class="alert alert-danger" v-if="error_msg.length > 0">
            <strong>Warning!</strong> Perbaiki hasil input Anda :
            <ul>
              <li v-for="text in error_msg" :key="text">{{ text }}</li>
            </ul>
          </div>
          <div class="mb-5">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <ValidationProvider name="Password Lama" rules="required" v-slot="{ errors }">
                  <base-input type="password" label="Password Lama"  placeholder="Password Lama" addon-left-icon="ni ni-lock-circle-open"
                    v-model="form.old_password" :required="true" :error="errors[0]" :valid="!errors[0]"></base-input>
                </ValidationProvider>
              </div>
              <div class="col-md-12 col-sm-12">
                <ValidationProvider  name="Password Baru" rules="required" v-slot="{ errors }">
                  <base-input label="Password Baru" type="password" placeholder="Password Baru" addon-left-icon="ni ni-lock-circle-open"
                    v-model="form.password" :required="true" :error="errors[0]" :valid="!errors[0]"></base-input>
                </ValidationProvider>
              </div>
              <div class="col-md-12 col-sm-12">
                <ValidationProvider name="Password Konfirmasi" rules="required" v-slot="{ errors }">
                  <base-input label="Konfirmasi Password Baru"  type="password" placeholder="Password Konfirmasi" addon-left-icon="ni ni-lock-circle-open"
                    v-model="form.password_confirmation" :required="true" :error="errors[0]" :valid="!errors[0]">
                  </base-input>
                </ValidationProvider>
              </div>
            </div>
            <div class="row float-right">
              <div class="col-md-12 col-sm-12">
                <template v-if="isBusy">
                  <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                  <strong>Loading...</strong>
                </template>
                <base-button v-else type="success" nativeType="submit" icon="ni ni-send">Ubah Password</base-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import qs from "qs";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    Modal,
    PulseLoader,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    isNpwpd: {
      type: Boolean,
      description: "isNPWPD or Email"
    },
  },
  data() {
    return {
      modals: {
        modal1: false,
      },
      form: {
        old_password: null,
        password: null,
        password_confirmation: null,
      },
      items: [],
      isBusy: false,
      error_msg: [],
    };
  },
  methods: {
    showModal() {
      this.error_msg = [];
      this.items = [];
      this.form.password = null;
      this.form.password_confirmation = null;
      this.form.old_password = null;
      this.modals.modal1 = true;
    },
    hideModal() {
      this.modals.modal1 = false;
    },
    async register() {
      const me = this;
      me.error_msg = [];
      try {
        this.isBusy = true;
        let { status } = me.isNpwpd ? await axios.post(
          "/api/v1/change_password",
          qs.stringify({ user: me.form })
        ) : await axios.post(
          "/api/v1/user/change_password",
          qs.stringify({ user: me.form })
        );

        if (status >= 200 && status <= 202) {
          Swal.fire({
            title: "",
            text:
              "Password Berhasil Berganti.",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Tutup!",
          }).then(async () => {
            me.hideModal();
          });
        }
      } catch (error) {
        // console.log(error)
        Swal.fire({
          title: "",
          text: error.message,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Tutup!",
        });
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>